import { createAction } from '@reduxjs/toolkit';

export const oauthPageEntered = createAction('OAUTH_PAGE_ENTERED');
